import styled from 'styled-components/macro'

import { Widget } from '../Widget'

export const Chart = styled(Widget)`
  min-height: 200px;
`
